import React, { useState } from "react";
import { Send, Mail, User, Phone, ChevronDown, MessageSquare } from "lucide-react";
import form from "../img/form.png";

// Country codes + basic phone rules
const COUNTRIES = [
  { code: "IN", name: "India", dialCode: "+91", phonePattern: /^[6-9]\d{9}$/, minLength: 10, maxLength: 10 },
  { code: "US", name: "United States", dialCode: "+1", phonePattern: /^\d{10}$/, minLength: 10, maxLength: 10 },
  { code: "GB", name: "United Kingdom", dialCode: "+44", phonePattern: /^\d{10,11}$/, minLength: 10, maxLength: 11 },

  // Other countries: generic 6–15 digits rule
  { code: "AF", name: "Afghanistan", dialCode: "+93", minLength: 6, maxLength: 15 },
  { code: "AL", name: "Albania", dialCode: "+355", minLength: 6, maxLength: 15 },
  { code: "DZ", name: "Algeria", dialCode: "+213", minLength: 6, maxLength: 15 },
  { code: "AD", name: "Andorra", dialCode: "+376", minLength: 6, maxLength: 15 },
  { code: "AO", name: "Angola", dialCode: "+244", minLength: 6, maxLength: 15 },
  { code: "AR", name: "Argentina", dialCode: "+54", minLength: 6, maxLength: 15 },
  { code: "AM", name: "Armenia", dialCode: "+374", minLength: 6, maxLength: 15 },
  { code: "AU", name: "Australia", dialCode: "+61", minLength: 6, maxLength: 15 },
  { code: "AT", name: "Austria", dialCode: "+43", minLength: 6, maxLength: 15 },
  { code: "AZ", name: "Azerbaijan", dialCode: "+994", minLength: 6, maxLength: 15 },
  { code: "BD", name: "Bangladesh", dialCode: "+880", minLength: 6, maxLength: 15 },
  { code: "BE", name: "Belgium", dialCode: "+32", minLength: 6, maxLength: 15 },
  { code: "BT", name: "Bhutan", dialCode: "+975", minLength: 6, maxLength: 15 },
  { code: "BO", name: "Bolivia", dialCode: "+591", minLength: 6, maxLength: 15 },
  { code: "BA", name: "Bosnia and Herzegovina", dialCode: "+387", minLength: 6, maxLength: 15 },
  { code: "BW", name: "Botswana", dialCode: "+267", minLength: 6, maxLength: 15 },
  { code: "BR", name: "Brazil", dialCode: "+55", minLength: 6, maxLength: 15 },
  { code: "BG", name: "Bulgaria", dialCode: "+359", minLength: 6, maxLength: 15 },
  { code: "KH", name: "Cambodia", dialCode: "+855", minLength: 6, maxLength: 15 },
  { code: "CM", name: "Cameroon", dialCode: "+237", minLength: 6, maxLength: 15 },
  { code: "CA", name: "Canada", dialCode: "+1", minLength: 6, maxLength: 15 },
  { code: "CL", name: "Chile", dialCode: "+56", minLength: 6, maxLength: 15 },
  { code: "CN", name: "China", dialCode: "+86", minLength: 6, maxLength: 15 },
  { code: "CO", name: "Colombia", dialCode: "+57", minLength: 6, maxLength: 15 },
  { code: "CR", name: "Costa Rica", dialCode: "+506", minLength: 6, maxLength: 15 },
  { code: "HR", name: "Croatia", dialCode: "+385", minLength: 6, maxLength: 15 },
  { code: "CY", name: "Cyprus", dialCode: "+357", minLength: 6, maxLength: 15 },
  { code: "CZ", name: "Czech Republic", dialCode: "+420", minLength: 6, maxLength: 15 },
  { code: "DK", name: "Denmark", dialCode: "+45", minLength: 6, maxLength: 15 },
  { code: "DO", name: "Dominican Republic", dialCode: "+1", minLength: 6, maxLength: 15 },
  { code: "EC", name: "Ecuador", dialCode: "+593", minLength: 6, maxLength: 15 },
  { code: "EG", name: "Egypt", dialCode: "+20", minLength: 6, maxLength: 15 },
  { code: "EE", name: "Estonia", dialCode: "+372", minLength: 6, maxLength: 15 },
  { code: "ET", name: "Ethiopia", dialCode: "+251", minLength: 6, maxLength: 15 },
  { code: "FI", name: "Finland", dialCode: "+358", minLength: 6, maxLength: 15 },
  { code: "FR", name: "France", dialCode: "+33", minLength: 6, maxLength: 15 },
  { code: "DE", name: "Germany", dialCode: "+49", minLength: 6, maxLength: 15 },
  { code: "GH", name: "Ghana", dialCode: "+233", minLength: 6, maxLength: 15 },
  { code: "GR", name: "Greece", dialCode: "+30", minLength: 6, maxLength: 15 },
  { code: "HK", name: "Hong Kong", dialCode: "+852", minLength: 6, maxLength: 15 },
  { code: "HU", name: "Hungary", dialCode: "+36", minLength: 6, maxLength: 15 },
  { code: "IS", name: "Iceland", dialCode: "+354", minLength: 6, maxLength: 15 },
  { code: "ID", name: "Indonesia", dialCode: "+62", minLength: 6, maxLength: 15 },
  { code: "IR", name: "Iran", dialCode: "+98", minLength: 6, maxLength: 15 },
  { code: "IQ", name: "Iraq", dialCode: "+964", minLength: 6, maxLength: 15 },
  { code: "IE", name: "Ireland", dialCode: "+353", minLength: 6, maxLength: 15 },
  { code: "IL", name: "Israel", dialCode: "+972", minLength: 6, maxLength: 15 },
  { code: "IT", name: "Italy", dialCode: "+39", minLength: 6, maxLength: 15 },
  { code: "JP", name: "Japan", dialCode: "+81", minLength: 6, maxLength: 15 },
  { code: "JO", name: "Jordan", dialCode: "+962", minLength: 6, maxLength: 15 },
  { code: "KE", name: "Kenya", dialCode: "+254", minLength: 6, maxLength: 15 },
  { code: "KW", name: "Kuwait", dialCode: "+965", minLength: 6, maxLength: 15 },
  { code: "LA", name: "Laos", dialCode: "+856", minLength: 6, maxLength: 15 },
  { code: "LV", name: "Latvia", dialCode: "+371", minLength: 6, maxLength: 15 },
  { code: "LB", name: "Lebanon", dialCode: "+961", minLength: 6, maxLength: 15 },
  { code: "LT", name: "Lithuania", dialCode: "+370", minLength: 6, maxLength: 15 },
  { code: "LU", name: "Luxembourg", dialCode: "+352", minLength: 6, maxLength: 15 },
  { code: "MY", name: "Malaysia", dialCode: "+60", minLength: 6, maxLength: 15 },
  { code: "MV", name: "Maldives", dialCode: "+960", minLength: 6, maxLength: 15 },
  { code: "MT", name: "Malta", dialCode: "+356", minLength: 6, maxLength: 15 },
  { code: "MX", name: "Mexico", dialCode: "+52", minLength: 6, maxLength: 15 },
  { code: "MA", name: "Morocco", dialCode: "+212", minLength: 6, maxLength: 15 },
  { code: "MM", name: "Myanmar", dialCode: "+95", minLength: 6, maxLength: 15 },
  { code: "NP", name: "Nepal", dialCode: "+977", minLength: 6, maxLength: 15 },
  { code: "NL", name: "Netherlands", dialCode: "+31", minLength: 6, maxLength: 15 },
  { code: "NZ", name: "New Zealand", dialCode: "+64", minLength: 6, maxLength: 15 },
  { code: "NG", name: "Nigeria", dialCode: "+234", minLength: 6, maxLength: 15 },
  { code: "NO", name: "Norway", dialCode: "+47", minLength: 6, maxLength: 15 },
  { code: "OM", name: "Oman", dialCode: "+968", minLength: 6, maxLength: 15 },
  { code: "PK", name: "Pakistan", dialCode: "+92", minLength: 6, maxLength: 15 },
  { code: "PA", name: "Panama", dialCode: "+507", minLength: 6, maxLength: 15 },
  { code: "PE", name: "Peru", dialCode: "+51", minLength: 6, maxLength: 15 },
  { code: "PH", name: "Philippines", dialCode: "+63", minLength: 6, maxLength: 15 },
  { code: "PL", name: "Poland", dialCode: "+48", minLength: 6, maxLength: 15 },
  { code: "PT", name: "Portugal", dialCode: "+351", minLength: 6, maxLength: 15 },
  { code: "QA", name: "Qatar", dialCode: "+974", minLength: 6, maxLength: 15 },
  { code: "RO", name: "Romania", dialCode: "+40", minLength: 6, maxLength: 15 },
  { code: "RU", name: "Russia", dialCode: "+7", minLength: 6, maxLength: 15 },
  { code: "SA", name: "Saudi Arabia", dialCode: "+966", minLength: 6, maxLength: 15 },
  { code: "RS", name: "Serbia", dialCode: "+381", minLength: 6, maxLength: 15 },
  { code: "SG", name: "Singapore", dialCode: "+65", minLength: 6, maxLength: 15 },
  { code: "SK", name: "Slovakia", dialCode: "+421", minLength: 6, maxLength: 15 },
  { code: "SI", name: "Slovenia", dialCode: "+386", minLength: 6, maxLength: 15 },
  { code: "ZA", name: "South Africa", dialCode: "+27", minLength: 6, maxLength: 15 },
  { code: "KR", name: "South Korea", dialCode: "+82", minLength: 6, maxLength: 15 },
  { code: "ES", name: "Spain", dialCode: "+34", minLength: 6, maxLength: 15 },
  { code: "LK", name: "Sri Lanka", dialCode: "+94", minLength: 6, maxLength: 15 },
  { code: "SE", name: "Sweden", dialCode: "+46", minLength: 6, maxLength: 15 },
  { code: "CH", name: "Switzerland", dialCode: "+41", minLength: 6, maxLength: 15 },
  { code: "TW", name: "Taiwan", dialCode: "+886", minLength: 6, maxLength: 15 },
  { code: "TH", name: "Thailand", dialCode: "+66", minLength: 6, maxLength: 15 },
  { code: "TR", name: "Turkey", dialCode: "+90", minLength: 6, maxLength: 15 },
  { code: "UA", name: "Ukraine", dialCode: "+380", minLength: 6, maxLength: 15 },
  { code: "AE", name: "United Arab Emirates", dialCode: "+971", minLength: 6, maxLength: 15 },
  { code: "UY", name: "Uruguay", dialCode: "+598", minLength: 6, maxLength: 15 },
  { code: "UZ", name: "Uzbekistan", dialCode: "+998", minLength: 6, maxLength: 15 },
  { code: "VE", name: "Venezuela", dialCode: "+58", minLength: 6, maxLength: 15 },
  { code: "VN", name: "Vietnam", dialCode: "+84", minLength: 6, maxLength: 15 },
  { code: "YE", name: "Yemen", dialCode: "+967", minLength: 6, maxLength: 15 },
  { code: "ZM", name: "Zambia", dialCode: "+260", minLength: 6, maxLength: 15 },
  { code: "ZW", name: "Zimbabwe", dialCode: "+263", minLength: 6, maxLength: 15 },
];

const QuoteForm = () => {
  const [selectedCountry, setSelectedCountry] = useState("IN");

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneno: "",
    service: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState({ type: "", message: "" });

  // field-level validation errors
  const [errors, setErrors] = useState({});

  const getSelectedCountry = () =>
    COUNTRIES.find((c) => c.code === selectedCountry) || COUNTRIES[0];

  const handleInputChange = (field) => (e) => {
    const value = e.target.value;

    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleCountryChange = (e) => {
    setSelectedCountry(e.target.value);
    setErrors((prev) => ({ ...prev, country: "" }));
  };

  // PHONE VALIDATION – strict & country-specific
  const validatePhone = (rawValue) => {
    const country = getSelectedCountry();
    const value = rawValue.trim();

    if (!value) {
      return "Phone number is required.";
    }

    // Only allow digits
    if (/[^0-9]/.test(value)) {
      return "Phone number must contain digits only (no spaces or symbols).";
    }

    const digits = value; // value is already digits-only now
    const min = country.minLength || 6;
    const max = country.maxLength || 15;

    // If regex pattern defined for this country, use it
    if (country.phonePattern && !country.phonePattern.test(digits)) {
      if (country.code === "IN") {
        return "Please enter a valid Indian mobile number (10 digits, starting from 6–9).";
      }
      if (country.code === "US") {
        return "Please enter a valid US mobile number (10 digits).";
      }
      if (country.code === "GB") {
        return "Please enter a valid UK mobile number (10–11 digits).";
      }
      return `Please enter a valid ${country.name} phone number.`;
    }

    // Fallback digit-length validation
    if (digits.length < min || digits.length > max) {
      return `Phone number must be between ${min} and ${max} digits.`;
    }

    return "";
  };

  const validateForm = () => {
    const newErrors = {};
    const { name, email, phoneno, service, message } = formData;
    const country = getSelectedCountry();

    if (!name.trim()) {
      newErrors.name = "Name is required.";
    }

    if (!email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/^\S+@\S+\.\S+$/.test(email)) {
      newErrors.email = "Please enter a valid email address.";
    }

    if (!selectedCountry) {
      newErrors.country = "Please select a country code.";
    } else if (!country?.dialCode) {
      newErrors.country = "Selected country is not valid.";
    }

    const phoneError = validatePhone(phoneno);
    if (phoneError) {
      newErrors.phoneno = phoneError;
    }

    if (!service.trim()) {
      newErrors.service = "Please select a service.";
    }

    if (!message.trim()) {
      newErrors.message = "Message is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: "", message: "" });

    const isValid = validateForm();
    if (!isValid) {
      setStatus({
        type: "error",
        message: "Please correct the highlighted fields and try again.",
      });
      return;
    }

    setIsSubmitting(true);

    const country = getSelectedCountry();
    const digitsOnlyPhone = formData.phoneno.trim(); // already validated as digits-only

    const payload = {
      name: formData.name,
      email: formData.email,
      country_code: country?.dialCode || "",
      phoneno: digitsOnlyPhone,
      service: formData.service,
      message: formData.message,
    };

    try {
      const res = await fetch("https://api.securxperts.com:8000/forms/quotation", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        throw new Error("Failed to submit form");
      }

      setStatus({
        type: "success",
        message: "Your request has been submitted successfully.",
      });

      setFormData({
        name: "",
        email: "",
        phoneno: "",
        service: "",
        message: "",
      });
      setSelectedCountry("IN");
      setErrors({});
    } catch (error) {
      setStatus({
        type: "error",
        message: "Something went wrong. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="bg-gray-50 py-16 px-6 lg:px-12">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        {/* ---------------- LEFT: FORM SECTION ---------------- */}
        <div>
          <h5 className="text-blue-600 font-semibold text-sm uppercase tracking-wider flex items-center gap-2">
            <MessageSquare className="h-4 w-4 text-blue-600" />
            Request a Quote
          </h5>

          <h2 className="text-4xl font-bold text-gray-900 mt-2 mb-4">
            Have Any <span className="text-blue-600">Questions?</span>
          </h2>

          <p className="text-gray-600 mb-8">
            Make the right business decision by connecting with us!
          </p>

          <form className="space-y-4" onSubmit={handleSubmit}>
            {/* Name + Email */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="relative">
                <User className="absolute top-3 right-3 text-gray-400 h-5 w-5" />
                <input
                  type="text"
                  placeholder="Full Name"
                  className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                  required
                  value={formData.name}
                  onChange={handleInputChange("name")}
                  name="name"
                />
                {errors.name && (
                  <p className="mt-1 text-xs text-red-600">{errors.name}</p>
                )}
              </div>

              <div className="relative">
                <Mail className="absolute top-3 right-3 text-gray-400 h-5 w-5" />
                <input
                  type="email"
                  placeholder="Email Address"
                  className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                  required
                  value={formData.email}
                  onChange={handleInputChange("email")}
                  name="email"
                />
                {errors.email && (
                  <p className="mt-1 text-xs text-red-600">{errors.email}</p>
                )}
              </div>
            </div>

            {/* Country Code + Phone */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Country Code Dropdown */}
              <div className="relative">
                <select
                  className="appearance-none w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-gray-700"
                  value={selectedCountry}
                  onChange={handleCountryChange}
                >
                  <option value="">-- Select Country Code --</option>
                  {COUNTRIES.map((country) => (
                    <option key={country.code} value={country.code}>
                      {country.name} ({country.dialCode})
                    </option>
                  ))}
                </select>
                <ChevronDown className="absolute top-3 right-3 text-gray-400 h-5 w-5" />
                {errors.country && (
                  <p className="mt-1 text-xs text-red-600">{errors.country}</p>
                )}
              </div>

              {/* Phone Number Field */}
              <div className="relative">
                <Phone className="absolute top-3 right-3 text-gray-400 h-5 w-5" />
                <input
                  type="tel"
                  placeholder="Phone Number"
                  className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                  required
                  value={formData.phoneno}
                  onChange={handleInputChange("phoneno")}
                  name="phoneno"
                />
                {errors.phoneno && (
                  <p className="mt-1 text-xs text-red-600">{errors.phoneno}</p>
                )}
              </div>
            </div>

            {/* Services Dropdown */}
            <div className="relative">
              <select
                className="appearance-none w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-gray-700"
                required
                value={formData.service}
                onChange={handleInputChange("service")}
                name="service"
              >
                <option value="">-- Select a Service --</option>
                <option value="web">Web Development</option>
                <option value="app">Mobile App Development</option>
                <option value="design">UI/UX Design</option>
                <option value="marketing">Digital Marketing</option>
                <option value="consulting">Consulting</option>
                <option value="other">Other</option>
              </select>
              <ChevronDown className="absolute top-3 right-3 text-gray-400 h-5 w-5" />
              {errors.service && (
                <p className="mt-1 text-xs text-red-600">{errors.service}</p>
              )}
            </div>

            {/* Message Field */}
            <div className="relative">
              <textarea
                placeholder="Write your message here..."
                rows="4"
                className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                required
                value={formData.message}
                onChange={handleInputChange("message")}
                name="message"
              ></textarea>
              <MessageSquare className="absolute top-3 right-3 text-gray-400 h-5 w-5" />
              {errors.message && (
                <p className="mt-1 text-xs text-red-600">{errors.message}</p>
              )}
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg text-sm font-semibold shadow-md transition flex items-center gap-2 justify-center w-full md:w-auto disabled:opacity-60 disabled:cursor-not-allowed"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
              <Send className="h-4 w-4" />
            </button>

            {status.message && (
              <p
                className={`text-sm mt-2 ${
                  status.type === "success" ? "text-green-600" : "text-red-600"
                }`}
              >
                {status.message}
              </p>
            )}
          </form>
        </div>

        {/* ---------------- RIGHT: IMAGE SECTION ---------------- */}
        <div className="flex justify-center lg:justify-end items-center">
          <img
            src={form}
            alt="Smiling professional holding laptop"
            className="w-full max-w-sm md:max-w-md lg:max-w-lg object-contain rounded-xl drop-shadow-lg"
          />
        </div>
      </div>
    </section>
  );
};

export default QuoteForm;
